package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet

import co.touchlab.kermit.Logger
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.essenty.lifecycle.doOnDestroy
import com.arkivanov.essenty.lifecycle.doOnStart
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import org.koin.core.component.KoinComponent
import tta.destinigo.talktoastro.feature_call_consultation.data.request.RemoveQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.QueueStatusRequest
import tta.destinigo.talktoastro.feature_call_consultation.domain.QueueRepo
import tta.destinigo.talktoastro.feature_call_consultation.domain.model.QueueStatusUiData
import tta.destinigo.talktoastro.shared.data.CommonExpertInfo
import tta.destinigo.talktoastro.shared.remote.Resources

class QueueStatusComponent(
    val expertInfo: CommonExpertInfo,
    componentContext: ComponentContext,
    val onDismiss: (isRemoved: Boolean) -> Unit,
    val errorQueueMsg:String? = null
) : ComponentContext by componentContext, KoinComponent {

    private val coroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val scope = getKoin().createScope<QueueStatusComponent>()
    private val repository: QueueRepo by scope.inject()

    private val _errorMsgStat = MutableStateFlow<String?>(null)
    val errorMsgStat = _errorMsgStat.asStateFlow()

    fun setErrorMst(msg:String?) = run { _errorMsgStat.value = msg }

    private val _users = MutableStateFlow<Resources<QueueStatusUiData>?>(null)
    val users = _users.asStateFlow()

    private val _statusState = MutableStateFlow<Resources<String>?>(null)
    val statusState = _statusState.asStateFlow()


    init {
        doOnStart {
            setErrorMst(errorQueueMsg)
            getQueueStatus()
        }
        doOnDestroy {
            coroutineScope.cancel()
        }
    }

    private fun getQueueStatus() {
        val request = QueueStatusRequest(
            expertInfo.expertId.toString()
        )

        coroutineScope.launch {
            repository.getQueueStatus(request).collect {
                println("Queue Status: $it")
                _users.value = it
            }
        }
    }

    fun removeQueue() {
        val request = RemoveQueueRequest(
            expertInfo.expertId.toString()
        )
        onRemoveQueue(request)
    }

    private fun onRemoveQueue(removeQueueRequest: RemoveQueueRequest) {
        coroutineScope.launch {
            repository.removeQueue(removeQueueRequest).collect {
                _statusState.emit(it)
            }
        }
    }

    private fun logMe(msg: String) {
        Logger.d(tag = "QUEUE_COMPONENT", messageString = msg)
    }

}